// extracted by mini-css-extract-plugin
export var activityContainer = "_fk-0";
export var typingIndicatorContainer = "_fk-1";
export var typingIndicatorDot = "_fk-2";
export var wave = "_fk-3";